import { BlankSlate } from "@msuite/ui/blank-slate";
import { Combobox } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { Tables } from "@msuite/utils/types";
import { useFormContext } from "react-hook-form";

/** Props Interface */
interface SelectCalculationFormProps {
	calculations: Tables<"serviceCalculations">[];
}

export function SelectCalculationForm({ calculations }: SelectCalculationFormProps) {
	/** Context */
	const methods = useFormContext<{ calculationId: string }>();

	/** Hooks */
	const { t } = useTranslation();

	if (calculations.length === 0) {
		return <BlankSlate />;
	}

	/** Render */
	return (
		<Combobox
			defaultValue={calculations[0]?.id ?? undefined}
			isNullable={false}
			control={methods.control}
			name="calculationId"
			options={calculations.map((calculation) => ({
				label: calculation.name,
				value: calculation.id,
				item: calculation,
			}))}
			displayValue={(item) => item.label}
			keyExtractor={(item) => item.value}
			placeholder={t("placeholders.search")}
			label={t("calculations.calculation")}
			isRequired
		/>
	);
}
